import React from 'react'

export const META_DE: metaType = {
  articleid: '244907341672',
  title: 'Auf der Spur der Dioxine',
  lead:
    'Die Schadstoffe sind hochtoxisch und überall in der Umwelt zu finden. Aber wie entstehen sie – und was macht sie so gefährlich? Die wichtigsten Antworten finden Sie hier.',
  authors: 'Roland Gamp, Jürg Candrian, Sebastian Broschinski',
  date: 'Aktualisiert am 22. August 2021',
  credits: [
    ['Illustrationen', 'Jürg Candrian, Sebastian Broschinski'],
    ['Text, Recherche', 'Roland Gamp, Dominique Botti'],
    ['Umsetzung', 'Sebastian Broschinski']
  ],
  star: (
    <>
      * Die Giftigkeit der verschiedenen Dioxine schwankt stark. Sie werden
      daher immer relativ zu ihrer Toxizität angegeben – harmlose Varianten
      werden weniger gewichtet, extrem toxische Varianten stärker.
      Grundlage bildet dabei das hochgiftige Seveso-Dioxin.
    </>
  )
}
export const TEXT_DE: textType[] = [
  {
    illu: require('images/dioxin_01.svg'),
    ground: { y: 90, color: '#efece0' },
    annotations: [
      {
        text: (
          <>
            In den <b>30 Schweizer KVA</b> werden pro Jahr rund{' '}
            <b>4 Mio. Tonnen Abfall</b> verbrannt.
          </>
        ),
        pos: { x: 2, y: 55 },
        align: 'right',
        maxWidth: 40,
        arrow: {
          type: 'right_bottom',
          pos: { right: '-30px', bottom: '-30px' }
        }
      },
      {
        text: (
          <>
            <b>Pro Jahr</b> stossen die Kehricht&shy;verbrennungs­&shy;anlagen{' '}
            <b>rund 2 Gramm Dioxine</b> aus.
          </>
        ),
        pos: { x: 65, y: 45 },
        maxWidth: 30,
        arrow: { type: 'left_top', pos: { left: 0, top: '-30px' } }
      }
    ],
    title: 'Gift aus Abfall',
    text: (
      <>
        30 Kehricht&shy;verbrennungs&shy;anlagen (KVA) sind aktuell in der
        Schweiz aktiv. Sie haben im letzten Jahr 4’071’643 Tonnen Abfall
        verbrannt. Die Energie, die dabei entsteht, wird als Wärme, Dampf oder
        Strom genutzt – fast 5784 Gigawatt&shy;stunden exportierten die KVA im
        Jahr 2020. Die Anlagen arbeiten heute mit speziellen Filtern und
        Verfahren, um Schadstoff&shy;emissionen zu minimieren. Denn bei der
        Verbrennung können neben CO2 auch hochtoxische Nebenprodukte wie zum
        Beispiel Dioxine entstehen. Rund 2 Gramm* davon stiessen alle KVA
        zusammen laut Bundesamt für Umwelt im letzten Jahr aus. 1985 waren es
        noch 250 Gramm gewesen.
      </>
    )
  },
  {
    illu: require('images/dioxin_02.svg'),
    annotations: [
      {
        text: (
          <>
            Eine KVA darf pro Kubikmeter Abgas{' '}
            <b>maximal 0.1 Nanogramm Dioxine</b> ausstossen.
          </>
        ),
        pos: { x: 15, y: 5 },
        maxWidth: 50,
        align: 'right',
        arrow: {
          type: 'bottom_right',
          pos: { right: '-30px', bottom: '-30px' }
        }
      }
    ],
    title: 'Die Chemie der Dioxine',
    text: (
      <>
        Dioxin ist ein Sammelbegriff für eine Gruppe von chemischen Verbindungen
        (den polychlorierten Dibenzo&shy;dioxinen und Dibenzo&shy;furanen).
        Diese haben immer die gleiche Grundstruktur, unterscheiden sich aber in
        der Anzahl und Anordnung der Chlor-Atome. Einige Varianten sind relativ
        harmlos, andere hochtoxisch. Am gefährlichsten ist das «Seveso-Dioxin»,
        das nach einem Chemieunfall in Italien im Jahr 1976 benannt wurde. Laut
        dem deutschen Umweltbundesamt ist die Substanz 500 mal giftiger als
        Strychnin. Industriell hergestellt werden Dioxine nicht. Sie entstehen
        aber in kleinsten Mengen als Verunreinigungen, wenn chlorhaltiges
        Material und organische Substanzen zusammen stark erhitzt werden. Also
        zum Beispiel bei der Abfallverbrennung. Für KVA gilt ein strenger
        Grenzwert, sie dürfen maximal 0.1 Nanogramm* Dioxine pro Kubikmeter
        Abgas ausstossen. Die meisten Dioxine gelangen heute stattdessen durch
        die private, illegale Verbrennung in die Umwelt.{' '}
      </>
    )
  },
  {
    illu: require('images/dioxin_03.svg'),
    ground: { y: 89.8, color: '#7B7768' },

    annotations: [
      {
        text: (
          <>
            Die Schadstoffe werden über bis zu <b>drei Kilometer</b> verteilt.
          </>
        ),
        pos: { x: 30, y: 60 },
        maxWidth: 30,
        arrow: { type: 'right_top', pos: { right: 0, top: '-30px' } }
      }
    ],
    title: 'In die Luft und zu Boden',
    text: (
      <>
        Dioxine binden sich in der Luft fast immer an Staubpartikel und gehen
        zusammen mit diesen im Umfeld der Emissionsquelle zu Boden. Experten
        gehen je nach Windsituation von einer Distanz bis zu drei Kilometern
        aus.
      </>
    )
  },
  {
    illu: require('images/dioxin_04.svg'),
    annotations: [
      {
        text: (
          <>
            Ab <b>5 Nanogramm Dioxine</b> pro Kilo&shy;gramm Boden ist die{' '}
            <b>Boden&shy;frucht&shy;barkeit nicht mehr gewährleistet.</b>
          </>
        ),
        pos: { x: 10, y: 4 },
        maxWidth: 60,
        align: 'right',
        arrow: {
          type: 'bottom_right',
          pos: { right: '-30px', bottom: '-30px' }
        }
      }
    ],
    title: 'Jahrzehnte lang im Untergrund',
    text: (
      <>
        Einmal im Boden, bauen sich Dioxine nur extrem langsam ab. Laut einem
        Bericht des Kantons Zürich dauert es mehrere Jahrzehnte, bis sich ihre
        Menge halbiert. Zentral ist daher die Frage, wie viele Dioxine von
        früheren Emissionen im Untergrund stecken. Der Bund hat je nach Nutzung
        verschiedene Grenzwerte festgelegt, etwa für Spielplätze oder
        landwirtschaftlich genutzte Flächen. Ab dem Richtwert von 5 Nanogramm*
        pro Kilogramm Boden ist die Boden&shy;frucht&shy;barkeit nicht mehr
        gewährleistet. Ist das zu erwarten, so sorgen die Behörden für eine
        Über&shy;wachung. Allerdings haben verschiedene Kantone noch gar nie
        Tests im Umkreis von KVA gemacht.
      </>
    )
  },
  {
    illu: require('images/dioxin_05.svg'),
    ground: { y: 83, color: '#d1e3d7' },
    annotations: [
      {
        text: (
          <>
            Ein Gramm Fett (Rohmilch) darf maximal <b>2.5 Picogramm Dioxine</b>{' '}
            enthalten.
          </>
        ),
        pos: { x: 35, y: 84},
        maxWidth: 50,
    
      }
    ],
    title: 'Der Weg in die Nahrungskette',
    text: (
      <>
        Lagert sich dioxinbelasteter Staub aus der Luft auf Früchten und Gemüse
        ab, kann er in der Regel abgewaschen werden. Problematisch wird es, wenn
        Tiere Dioxine über das Futter oder Bodenpartikel aufnehmen. Denn die
        Substanz reichert sich im Körperfett an, ihre Konzentration im Tier
        steigt also mit der Zeit. Schliesslich können die Schadstoffe über
        tierfetthaltige Lebensmittel wie Milch, Fleisch, Fisch oder Eier in den
        menschlichen Körper gelangen. Es gibt daher auch für Lebensmittel
        verbindliche Grenzwerte. Ein Gramm Fett von Rohmilch darf zum Beispiel
        in der Schweiz nur 2.5 Picogramm* (Billionstel Gramm) Dioxine enthalten.
      </>
    )
  },
  {
    illu: require('images/dioxin_06.svg'),
    annotations: [
      {
        text: (
          <>
            <b>1.75 Picogramm Dioxine</b> pro kg Körpergewicht nehmen Schweizer
            täglich auf
          </>
        ),
        pos: { x: 4, y: 0 },
        maxWidth: 30,
        align: 'right'
      }
    ],
    title: 'Kleinste Mengen problematisch',
    text: (
      <>
        Die Schweizer Bevölkerung nimmt laut einem Bericht des Bundesamts für
        Lebensmittel&shy;sicherheit deutlich mehr Dioxine zu sich, als empfohlen
        wird. Durchschnittlich liegt die Aufnahme pro Tag und Kilo Körpergewicht
        bei 1.75 Picogramm* Dioxine. Das entspricht der sechsfachen Menge
        dessen, was die Europäischen Behörde für Lebensmittelsicherheit als
        «tolerierbar» einstuft. Akute Folgen hat die Aufnahme der kleinen Mengen
        über die Nahrung nicht – kritisch ist die chronische Belastung. Der Bund
        und die WHO stufen gewisse Dioxine als krebserzeugend ein. Sie können
        nach aktuellem Stand der Forschung das Nerven- und das Immunsystem
        schädigen und den Hormon&shy;haushalt beeinträchtigen. <br />
        <br />
      </>
    )
  }
]
